import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PdfSmallOrderViewRoutingModule } from './pdf-small-order-view-routing.module';
import { PdfSmallOrderViewComponent } from './pdf-small-order-view.component';
import { PDFModule } from 'app/pdf/pdf.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { I18nModule } from 'app/shared/i18n/i18n.module';


@NgModule({
  declarations: [PdfSmallOrderViewComponent],
  imports: [
    CommonModule,
    PdfSmallOrderViewRoutingModule,
    PDFModule,
    NgxSpinnerModule,
    I18nModule
  ]
})
export class PdfSmallOrderViewModule { }
